import {screenIsBiggerOrEqualToLarge} from "../window"
import {CHEVRON_WIDTH, DRAWER_GAP} from "../../config/constants"

export const calcScrollOffset = (
    event: React.MouseEvent<EventTarget>,
    clickedElement: HTMLElement,
    snapPosition: number,
): number => {
    const {right: rightBorder, left: leftBorder, width: elementWidth} = clickedElement.getBoundingClientRect()
    const {clientX: cursorPosition} = event

    const drawerEnd = window.innerWidth - snapPosition - (screenIsBiggerOrEqualToLarge() ? DRAWER_GAP : 0)
    const cursorToDrawerEndOffset = cursorPosition - drawerEnd
    const cursorToRightBorderOffset = rightBorder - cursorPosition
    const linkSize = rightBorder - leftBorder

    const getButtonOrLinkOffset = () => (event.type === "click" ? 0 : linkSize / 2)
    const isOffsetLessThanZero = offset => offset < 0
    const isOffsetGreaterThanZero = offset => offset > 0

    const offset = cursorToDrawerEndOffset + cursorToRightBorderOffset + getButtonOrLinkOffset()
    const totalChevronWidth = CHEVRON_WIDTH + (screenIsBiggerOrEqualToLarge() ? DRAWER_GAP + CHEVRON_WIDTH * 2 : 0)

    if (rightBorder <= drawerEnd && isOffsetGreaterThanZero(offset)) {
        return 0
    }

    if (leftBorder > totalChevronWidth && isOffsetLessThanZero(offset)) {
        return 0
    }

    if (isOffsetLessThanZero(offset)) {
        return -elementWidth
    }

    return offset
}

export default calcScrollOffset
